function formatDate(dateData, time = false) {
  let date = new Date(dateData)
  let month = date.toLocaleString('default', { month: 'long' })
  let day = ("0" + date.getDate()).slice(-2)
  let year = date.getFullYear()

  if (time) {
    return day + ' ' + month + ', ' + year + ' ' + date.toLocaleTimeString()
  } else {
    return day + ' ' + month + ', ' + year
  }
}

export default formatDate
